import { CallTransferFormValues } from '../../store/call-transfer/CallTransferModel';

export const getTransferInitialValues = (callTransferField: CallTransferFormValues[]) => ({
  callTransferField,
  newCallerId: '',
  isPermanent: false,
});

export type CallTransferFormBody = ReturnType<typeof getTransferInitialValues>;
